import React from 'react'
import PropTypes from 'prop-types'
import reactHtmlParser from 'react-html-parser'

const OpenEndedComments = (props) => {
  const { data } = props

  return (
    <>
      <div className="question-container">{reactHtmlParser(data.question)}</div>
      <textarea className="preview-textarea" name="preview-textarea" rows="6" />
    </>
  )
}

OpenEndedComments.propTypes = {
  data: PropTypes.object.isRequired,
}

export default OpenEndedComments
